import React from "react";
import "./HomeCard.scss";

// Libraries & Packages
import { Link } from "react-router-dom";

// Utils
import { getServiceResources } from "../../Service/ServiceResourecesUtils";
import DynamicImage from "components/DynamicImage/DynamicImage";
import Navigation from "utils/navigation/Navigation";

function HomeCard({ title = "Logo Design" }) {
  const serviceResourses = getServiceResources(title);
  const link = Navigation.getLinkByTitle(title);
  return (
    <div className="homeCard">
      <Link to={`${link}`}>
        <DynamicImage
          title={[serviceResourses.title_top, serviceResourses.title_bottom]}
          image={serviceResourses.image}
        />
      </Link>
    </div>
  );
}

export default HomeCard;
